import React, { useEffect } from 'react';
import Footer from '@/components/Footer';
import Logo from '@/assets/tobiz-logo/logo.svg';
import LoginForm from './form';
import ThemeAndLangSelector from '@/components/ThemeAndLangSelector';
import styles from './style/index.module.less';
function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(ThemeAndLangSelector, null), /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-text']
  }, "Tobiz Account")), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(Footer, null))));
}
Login.displayName = 'LoginPage';
export default Login;